import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';

export const getConfig = async (): Promise<AxiosResponse> => {
	return await companiesApi.get('/config');
};
